export const IconLogoutAccount = () => {
    return (
        <svg width="83" height="82" viewBox="0 0 83 82" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2.19434" y="1.5" width="78.6062" height="78.6062" rx="39.3031" fill="#E50AAC" stroke="white" strokeWidth="3" />
            <g clipPath="url(#clip0_81_1430)">
                <path d="M20.4975 36.1244C11.4833 36.1244 4.17627 28.8174 4.17627 19.8032C4.17627 10.789 11.4833 3.48193 20.4975 3.48193C29.5117 3.48193 36.8188 10.789 36.8188 19.8032C36.8188 28.8174 29.5117 36.1244 20.4975 36.1244ZM28.6581 26.3317L36.8188 19.8032L28.6581 13.2747V18.1711H15.6011V21.4353H28.6581V26.3317Z" fill="white" transform="translate(20, 20)" />
            </g>
            <defs>
                <clipPath id="clip0_81_1430">
                    <rect width="59.171" height="59.171" fill="white" transform="translate(0.912109 0.217773)" />
                </clipPath>
            </defs>
        </svg>
    )
}